import { PlayerWithPlay } from '../stream/play';
import { EventKey, PlaybackState, } from './enums';
import { isPlaybackError, PlaybackError, } from '../errors';
import { ErrorCode } from '../errors/enums/error-code';
import { WithProperty } from './modules/property';
import { WithControl } from './modules/control';
import { WithTrack } from './modules/track';
import { WithEvent } from './modules/event';
import { WithTelemetry } from './modules/telemetry';
import { WithUtil } from './modules/util';
export class BasePlayer {
    _canPause = false;
    _canSeekBackward = false;
    _canSeekForward = false;
    _currentPosition = null;
    _duration = null;
    _logger;
    _playbackState = PlaybackState.STOPPED;
    _playbackStateInitial = true;
    _seekableRange = null;
    _mediaItem = null;
    _volume = 1;
    _playerOptions;
    _psid = null;
    _geometry = null;
    _bandwidth = null;
    _bitrate = null;
    _assetType = null;
    _sessions = [];
    _playOptions = null;
    _statsForNerdsVisible = false;
    _isPausedByUser = false;
    adapter;
    seekController = null;
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    triggerTelemetryEvent(payload) {
        // empty
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatchCustomTelemetryEvent(event) {
        // empty
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    triggerTelemetryNewSessionEvent(psid, assetType, assetId) {
        // empty
    }
    setCurrentPosition(position) {
        this._currentPosition = position;
        if (position != null) {
            this.seekController?.update(position, this._playbackState);
        }
    }
    getCurrentPosition() {
        return this._currentPosition;
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    triggerFullEvent(event, options) {
        // empty
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    triggerEvent(event) {
        // empty
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setPlayerState(stateChange) {
        // empty
    }
    seekPosition = null;
    constructor(playerOptions, adapter) {
        this.adapter = adapter;
        this._playerOptions = playerOptions;
        this._playerOptions.stepBackwardDuration ??= 30;
        this._playerOptions.stepForwardDuration ??= 60;
        this._logger = playerOptions.logging?.playerLogger;
    }
    hookMediaItem(media) {
        return media;
    }
    dispatchMedia(media, noEvent) {
        this._mediaItem = media;
        const extendedMedia = this.hookMediaItem(media);
        this._mediaItem = extendedMedia;
        if (!noEvent) {
            this.triggerEvent({
                type: EventKey.MEDIA_CHANGED,
                media: extendedMedia,
            });
        }
        return Promise.resolve(extendedMedia);
    }
    destroy() {
        return this.adapter.destroy();
    }
    get psid() {
        return this._psid;
    }
    set psid(newPsid) {
        this._psid = newPsid;
    }
    get bandwidth() {
        return this._bandwidth;
    }
    get isStatsForNerdsEnabled() {
        /* noop */
        return false;
    }
    // @ts-expect-error unused
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setStatsForNerds(enabled) {
        // empty
    }
    get isPausedByUser() {
        return this._isPausedByUser;
    }
    startNewSession() {
        const sessionAbortController = new AbortController();
        this._sessions.forEach((session) => {
            if (!session.signal.aborted) {
                session.abort();
            }
        });
        this._sessions = [sessionAbortController];
        return sessionAbortController;
    }
    handleError(error, psid) {
        const mappedError = this.mapError(error);
        this.triggerEvent({
            type: EventKey.PLAYER_ERROR,
            error: mappedError,
            psid,
        });
    }
    mapError(error) {
        if (isPlaybackError(error)) {
            return error;
        }
        return new PlaybackError(ErrorCode.Unknown, String(error));
    }
}
const PlayerWithModules = WithUtil(WithTelemetry(WithProperty(WithControl(WithTrack(WithEvent(BasePlayer))))));
export const Player = PlayerWithPlay(PlayerWithModules);
